import { render, staticRenderFns } from "./VisitAskManage.vue?vue&type=template&id=16dc8045&"
import script from "./VisitAskManage.vue?vue&type=script&lang=js&"
export * from "./VisitAskManage.vue?vue&type=script&lang=js&"
import style0 from "./VisitAskManage.vue?vue&type=style&index=0&id=16dc8045&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16dc8045')) {
      api.createRecord('16dc8045', component.options)
    } else {
      api.reload('16dc8045', component.options)
    }
    module.hot.accept("./VisitAskManage.vue?vue&type=template&id=16dc8045&", function () {
      api.rerender('16dc8045', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/asks/visit-ask-manage/VisitAskManage.vue"
export default component.exports